import './default_module'
import { navTabs,jqTextExpander, jqTextCopy } from 'javascripts/general_scripts.js'

/* stylesheet */
import 'javascripts/all_pages_styles.js'
import 'stylesheets/vendors/show.less'

navTabs();
jqTextCopy();

jqTextExpander();
$('.full-review').expander(13);